export var SEGMENT_API_HOST = 'api.segment.io/v1';
//# sourceMappingURL=index.js.map